import { NgModule } from '@angular/core';
import { VersionsListComponent } from './versions-list.component';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiRollupContentModule } from '@fi-shared/rollup/rollup-content.module';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, FiRollupContentModule],
    declarations: [VersionsListComponent],
    exports: [VersionsListComponent],
})
export class FiVersionsListModule {}
